<payee-chip-toggle
  [control]="control"
  [label]="'PAYEE_CASE_MOKK_TABLE.FILTERS.INCLUDE_WITHOUT_MEDIA' | translate"
></payee-chip-toggle>
